// What the tenant's category switches on (tenant.modules, see TenantLookupResponse). A tenant answered by an older API has
// no list: everything the school site always had stays on.
export const SCHOOL_MODULES = ["COURSES", "MEETINGS", "SCHOOL_STRUCTURE", "LESSONS", "EXAMS", "NEWS", "GALLERY", "RESOURCES", "INBOX"];

export function modulesOf(tenant) {
  return tenant && Array.isArray(tenant.modules) ? tenant.modules : SCHOOL_MODULES;
}

export function hasModule(tenant, module) {
  return modulesOf(tenant).indexOf(module) >= 0;
}

/** The category of the tenant ("school" for an older API). */
export function categoryOf(tenant) {
  return (tenant && tenant.categoryId) || "school";
}
